import { Base } from 'zf-web-components';
import styles from './index.module.less';
import type { ReactElement } from 'react';

export function ShoteyesPrivacyPage(): ReactElement {
  return (
    <Base.Layout className={styles.privacyContainer}>
      <div className={styles.container}>
        <h2 className={styles.title}>隐私声明</h2>
        <hr className={styles.divider} />
        <div>
          巡店助手（以及下文提到的“我们”、“我们的”或“本app”）是由主体公司字符科技（大连）有限公司提供的网络产品。
          <br />
          产品名称：巡店助手
          <br />
          产品类别：app
          <br />
          如果您决定使用我们产品提供的服务，本协议用于告知我们对于用户的隐私如何收集、使用和披露。
          <br />
          <b>
            如果您选择使用我们提供的服务，则表示您同意收集和使用与此政策相关的信息。我们收集的个人信息用于提供和改进服务。除非本隐私政策中另有说明，否则我们不会与任何人一起使用或分享您的信息。
          </b>
          <br />
          除非本隐私政策另有规定，否则本隐私政策中使用的术语与我们的条款和条件具有相同的含义，可在巡店助手中访问。
        </div>

        <h3>1、收集信息</h3>
        <div>
          我们收集您提供给我们的部分或全部信息，以及您使用网站和应用程序的数据，但我们将主要使用收集的数据为您提供满意的服务，并提高您的使用体验。
        </div>

        <h4>1.1、设备和技术信息的收集</h4>
        <div>
          我们可能会收集您使用我们的应用程序所需的数据，我们可以维护和分析应用程序的功能。
          <br />
          我们自动获得有关您的设备的某些信息，包括 IP 地址，国家代码，时区会话开始/停止时间；IDFVs，语言；网络状态（无线等），浏览器插件类型和版本；平台，SDK 版本，时间戳；技术设备信息（如设备型号和名称、操作系统名称和版本、CPU 信息、存储大小、屏幕大小、固件、应用程序的软件 API 密钥标识符、推送通知令牌）。虽然这些信息（如IDFV、IP地址）可能唯一地标识您的设备，但此信息并没有亲自识别您。某些立法（如美国）可以将您的设备唯一标识为个人信息的信息处理。
          <br />
          我们会收集您设备的ANDROID ID、IMSI、SD卡数据、IMEI、设备序列号、BSSID,SSID个人信息、传感器用于追踪您使用软件过程中产生的问题，便于及时处理。
          <br />
          我们会收集您设备的应用安装列表用于第三方授权登录，查找、收集日志，追踪您使用软件过程中产生的问题。
        </div>

        <h4>1.2、常规个人信息收集</h4>
        <div>
          在使用我们的服务时，我们可能会要求您向我们提供可用于联系或识别您的某些个人身份信息（“个人数据”），个人身份信息可能包括但不限于：
          <ul>
            <li>手机号码、登录密码</li>
            <li>[位置权限]： 我们会根据GPS获取您距离最近门店的位置信息，以及在拍照或上传图片时添加位置水印。</li>
            <li>[存储权限]： 用于共享文件、上传文件以及提交报告等服务功能。</li>
            <li>[相机权限]： 用于上传图片和视频等功能。</li>
          </ul>
        </div>

        <h4>1.3、APP第三方SDK共享信息收集</h4>
        <div>
          在使用我们的服务时，我们可能会要求您向我们提供可用于联系或识别您的某些个人身份信息（“个人数据”），个人身份信息可能包括但不限于：
          <table className={`${styles.table} ${styles.tableBordered}`}>
            <thead>
              <tr>
                <th>使用SDK名称</th>
                <th>第三方名称</th>
                <th>使用目的</th>
                <th>收集个人信息</th>
                <th>第三方隐私政策</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>高德开放平台定位SDK</th>
                <th>高德软件有限公司</th>
                <th>获取用户定位/展示所在位置附近地图</th>
                <th>位置信息（经纬度、精确位置、粗略位置）【通过IP 地址、GNSS信息、WiFi状态、WiFi参数、WiFi列表、基站信息、信号强度的信息、蓝牙信息、传感器信息（矢量、加速度、压力）、设备信号强度信息获取】</th>
                <th>隐私权政策链接<a href='https://lbs.amap.com/pages/privacy/'>https://lbs.amap.com/pages/privacy/</a></th>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <th>TBS腾讯浏览服务</th>
                <th>腾讯公司</th>
                <th>x5内核渲染webview/内存卡上的可用X5内核版本，以便提升用户的X5占比</th>
                <th>IMEI、IMSI、AndroidID、SDCard数据读写、读写外置存储器、读取手机状态和身份、BSSID,SSID个人信息</th>
                <th>隐私权政策链接<a href='https://x5.tencent.com/tbs/guide/develop.html#5'>https://x5.tencent.com/tbs/guide/develop.html#5</a></th>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <th>ReactNative</th>
                <th>Facebook</th>
                <th>软件基础架构</th>
                <th>获取设备传感器 监听传感器 SDCard数据读写</th>
                <th>隐私权政策链接<a href='https://reactnative.dev/'>https://reactnative.dev/</a></th>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <th>SENTRY平台（sentry-android,io.sentry.react）</th>
                <th>SENTRY</th>
                <th>崩溃日志收集</th>
                <th>获取设备传感器 SDCard数据读写 获取应用安装列表</th>
                <th>隐私权政策链接<a href='https://sentry.io/privacy/'>https://sentry.io/privacy/</a></th>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <th>友盟+SDK</th>
                <th>北京锐讯灵通科技有限公司</th>
                <th>崩溃日志收集</th>
                <th>获取硬件序列号 AndroidID BSSID,SSID个人信息 获取应用安装列表 获取ICCID个人信息</th>
                <th>隐私权政策链接<a href='https://www.umeng.com/policy'>https://www.umeng.com/policy</a></th>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <th>lightSDK（cn.alphabets.light）</th>
                <th>字符科技（大连）有限公司（本司）</th>
                <th>应用错误日志收集</th>
                <th>获取SDCard数据</th>
                <th>隐私权政策链接<a href='http://www.alphabets.cn/services'>http://www.alphabets.cn/services</a></th>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <th>com.xiaomi.push(小米;小米推送)</th>
                <th>小米科技有限责任公司</th>
                <th>给用户提供重要的消息和更新通知</th>
                <th>设备标识符和通知接收状态</th>
                <th>隐私权政策链接<a href='https://dev.mi.com/distribute/doc/details?pId=1534'>https://dev.mi.com/distribute/doc/details?pId=1534</a></th>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <th>com.heytap.msp(OPPO;OPush)</th>
                <th>OPPO广东移动通信有限公司</th>
                <th>给用户提供重要的消息和更新通知</th>
                <th>设备标识符和通知接收状态</th>
                <th>隐私权政策链接<a href='https://open.oppomobile.com/new/developmentDoc/info?id=10288'>https://open.oppomobile.com/new/developmentDoc/info?id=10288</a></th>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <th>com.android.dingtalk(钉钉)</th>
                <th>钉钉（中国）信息技术有限公司</th>
                <th>给用户提供重要的消息和更新通知</th>
                <th>设备标识符和通知接收状态 获取应用安装列表</th>
                <th>隐私权政策链接<a href='https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html'>https://terms.alicdn.com/legal-agreement/terms/suit_bu1_dingtalk/suit_bu1_dingtalk202010070946_49604.html</a></th>
              </tr>
            </tbody>
          </table>
        </div>

        <h3>2、如何使用收集的信息</h3>
        <div>
          巡店助手将收集的数据用于以下其中的部分或全部目的：
          <ul>
            <li>提供和维护服务</li>
            <li>通知您有关我们服务的更改</li>
            <li>允许您在选择时参与我们服务的互动功能</li>
            <li>为客户提供关怀和支持</li>
            <li>提供分析或有价值的信息，以便我们改进服务</li>
            <li>监控服务的使用情况</li>
            <li>检测，预防和解决技术问题当您通过移动设备访问服务时，我们可能会自动收集某些信息，包括但不限于您使用的移动设备类型，移动设备唯一ID，移动设备的IP地址，移动设备操作系统，您使用的移动互联网浏览器的类型，唯一的设备标识符和其他诊断数据（“使用数据”）</li>
          </ul>
        </div>

        <h3>3、信息存储</h3>

        <h4>3.1、数据安全</h4>
        <div>
          数据的安全性对我们很重要，但请记住，没有任何安全措施是完美的或不可渗透的。虽然我们努力使用商业上可接受的方式来保护您的个人数据，但我们无法保证其绝对的安全性。
        </div>

        <h4>3.2、数据传输</h4>
        <div>
          您的信息（包括个人数据）可能会被转移到您所在州，省，国家或其他政府管辖范围之外的计算机上，并且这些计算机的数据保护法可能与您所在司法管辖区的数据保护法不同。
          <br />
          如果您位于中国境外并选择向我们提供信息，请注意我们将数据（包括个人数据）传输到中国并在中国处理。
          <br />
          您同意本隐私政策，然后提交此类信息即表示您同意该转让。
        </div>

        <h4>3.3、数据披露</h4>
        <div>
          巡店助手可能会真诚地披露您的个人资料，相信此类行为是必要的：
          <ul>
            <li>履行法律义务</li>
            <li>保护和捍卫本软件的权利或财产</li>
            <li>防止或调查与服务相关的可能的不当行为</li>
            <li>保护服务或公众用户的人身安全</li>
            <li>防止法律责任</li>
          </ul>
        </div>

        <h4>3.4、服务供应商</h4>
        <div>
          我们可能雇用第三方（公司或个人）来促进我们的服务（“服务提供商”）。第三方代表我们提供服务，执行相关服务或协助我们分析服务的使用方式。第三方只能代表我们访问您的个人数据以执行这些任务，并且有义务不将其用于任何其他目的。
        </div>

        <h4>3.5、链接到其它网站</h4>
        <div>
          我们的服务可能包含指向非我们运营的其他网站的链接。如果您点击第三方链接，您将被引导至该第三方的网站。我们强烈建议您查看您访问的每个站点的隐私政策。我们无法控制任何第三方网站或服务的内容，隐私政策或做法，也不承担任何责任。
        </div>

        <h3>4、删除信息</h3>
        <div>
          当不再需要信息时，我们将使用合理的措施删除它，以保护信息不被未经授权的访问或使用。用户上传的内容如果涉嫌黄色、暴力不受欢迎内容我们将有权进行删除。
        </div>

        <h3>5、保护信息</h3>
        <div>
          我们已经实施了合理的安全措施，以保障收集信息的机密性、安全性和完整性，并防止未经授权的访问和使用违反本隐私政策的信息。虽然我们采取合理的努力，以保障您的信息在我们维护时依然安全，但请注意，没有任何安全措施是绝对安全的。
        </div>

        <h3>6、Cookie技术</h3>
        <div>
          我们使用Cookie和类似的跟踪技术来跟踪我们服务上的活动并保留某些信息。
          <br />
          Cookie是包含少量数据的文件，可能包含匿名唯一标识符。Cookie会从网站发送到您的浏览器并存储在您的设备上。还使用其他跟踪技术比如信标，标签和脚本等，用于收集和跟踪信息以及改进和分析我们的服务。
          <br />
          您可以指示您的浏览器拒绝所有Cookie或指示何时发送Cookie。但是，如果您不接受Cookie，您可能无法使用我们服务的某些部分。
          <br />
          我们使用的Cookie示例：
          <ul>
            <li>会话Cookie。我们使用Session Cookies来运营我们的服务。</li>
            <li>偏好Cookie。我们使用首选项Cookie来记住您的偏好和各种设置。</li>
            <li>安全Cookies。出于安全考虑，我们使用安全Cookie。</li>
          </ul>
        </div>

        <h3>7、自启动和关联启动说明</h3>
        <ul>
          <li>为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用（自启动)能力，将存在一定频率通过系统发送广播唤醒本应用自启动或关联启动行为,是因实现功能及服务所必要的。</li>
          <li>当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。</li>
          <li>当您打开本App内部下载的文件后，会关联启动第三方App。</li>
        </ul>

        <h3>8、第三方服务条款</h3>
        <div>
          我们产品使用高德地图服务进行定位，使用阿里云进行消息推送。
        </div>

        <h3>9、退出</h3>
        <div>
          根据本隐私政策，您可以从您的每台设备上卸载所有应用程序并停止使用本网站，从而永远自由地选择不参与将来在软件内收集您的个人信息。
        </div>

        <h3>10、个人信息主体注销账号</h3>
        <div>
          您可以随时注销您所注册的账号，注销账号的方式为：通过设置中的账号选项进行自助注销，或联系企业管理人员，我们进行即时注销处理。
        </div>
        <div>
          当您完成账号的注销后，我们将停止为您提供相应的产品和服务，并删除相关个人信息或进行匿名化处理，因法律法规另有规定而需要留存个人信息的除外（但不会再将相关信息用于日常业务活动）。
        </div>

        <h3>11、运营者基本信息</h3>
        <div>
          单位名称：字符科技（大连）有限公司
          <br />
          注册地址：大连市甘井子区七贤园13号3单元4层1号
          <br />
          办公地址：大连市高新园区腾讯大厦601
          <br />
          信息保护负责人联系电话：+86 134 7878 5024
        </div>

        <h3>12、支持</h3>
        <div>
          如果您对本隐私政策有任何疑问，请联系我们：
          <br />
          邮件：member@alphabets.cn
          <br />
          官网：https://www.alphabets.cn/shoteyes
          <br />
          电话：+86 186 4262 7048 (Mrs.邵)
          <br />
          +86 134 7878 5024 (Mr.沈)

        </div>

        <h3>13、对此隐私策略的更改</h3>
        <div>
          我们可能会不时更新我们的隐私政策。我们将通过在此页面上发布新的隐私政策来通知您任何更改。
          <br />
          建议您定期查看本隐私政策以了解任何变更。本隐私政策的更改在此页面上发布时生效。
        </div>

        <div>
          发布时间：2023年1月6日
          <br />
          生效时间：2023年1月6日
          <br />
          更新时间：2023年1月6日
        </div>
      </div>
    </Base.Layout>
  );
}

